import crud from "../../../crud";

crud.conf['w-image'] = {
    cssClass:'',
}

const wImageMixin = {

}
export default wImageMixin
